import { authenticatedFetch } from '@/utils/authSession';

function resolveFilename(response: Response, fallback: string): string {
  const disposition = response.headers.get('Content-Disposition');
  const match = disposition?.match(/filename="([^"]+)"/i);
  return match?.[1] ?? fallback;
}

export async function downloadAuthenticatedFile(
  path: string,
  _accessToken: string | null,
  fallbackFilename: string,
): Promise<string> {
  const response = await authenticatedFetch(path);

  if (!response.ok) {
    throw new Error('Download failed.');
  }

  const blob = await response.blob();
  const filename = resolveFilename(response, fallbackFilename);
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
  return filename;
}
